import React, { useState } from 'react';
import Container from '../components/home/container1';
import Header from '../components/home/header';
import SidebarComponent from './SidebarComponent';
import { GoogleAd } from '../components/ads/GoogleAd';
import Inputbox from '../components/interview-setup/inputbox';
import { useScreen } from '../contexts/screen.provider';


function Startup() {
  const [displaySidebar, setDisplaySidebar] = useState(false);
  const { isDesktop, isTablet } = useScreen()
  function changeSidebarDisplay() {
    setDisplaySidebar(prev => !prev);
  }

  return (
    <div className="w-full overflow-y-auto  h-screen   bg-white dark:bg-[#202020] flex flex-col ">
      <Header
        isAdsVisible={true}
        sidebarDisplay={displaySidebar}
        changeSidebarDisplay={changeSidebarDisplay}
      />
      <main className="flex mt-[6vh] custom-scrollbar overflow-x-hidden md:mt-[7vh] tablet:mt-[10vh] tablet:items-start  gap-2   tablet:px-4 px-0    flex-col items-center  tablet:flex-row flex-grow relative">
        <SidebarComponent setSidebarDisplay={setDisplaySidebar} sidebarDisplay={displaySidebar} />
        {isTablet && <div className="h-full w-full ">
          <GoogleAd />
        </div>}
        {isDesktop && <GoogleAd />}
        <Inputbox />
        {
          isDesktop

            ?
            <GoogleAd />

            : <div className=" w-full h-full">
              <GoogleAd />
            </div>
        }
      </main>

    </div>
  );
}

export default Startup;